import { useModal } from '../contexts';
import { useState } from 'react';
import { postData } from '../backend';
import { useHistory } from 'react-router-dom';
import useUser from '../hooks/useUser';
import Modal from './Modal';
import TextInputField from './TextInputField';

function CreateTeamModal() {
  const history = useHistory();

  const { refreshUser } = useUser();
  const { closeModal } = useModal();

  const [teamName, setTeamName] = useState<string>('');

  const [invalid, setInvalid] = useState(false);
  const [saving, setSaving] = useState(false);

  function handleUpdateName(name: string) {
    setInvalid(!name);
    setTeamName(name);
  }

  function handleCreate() {
    if (!teamName)
      return setInvalid(true);

    setSaving(true);
    postData("/auth/team/", { name: teamName })
      .then((team) => {
        setSaving(false);

        refreshUser();
        closeModal(() => history.push("/settings/team"));
      })
      .catch(console.error);
  }

  return (
    <Modal preventClose>
      <div className="flex flex-col items-center justify-center text-center bg-white" style={{ width: "500px", height: "300px" }}>
        <div className="text-xl font-gilroy font-bold mb-12">Thank you for signing up to Teams 🎉</div>
        <div className="text-lg font-gilroy font-bold mb-1">What is the name of your team?</div>
        <div style={{ width: 400 }}>
          <TextInputField className="w-full mb-2" value={teamName} onChange={handleUpdateName} onEnter={handleCreate} invalid={invalid} />
        </div>
        <div className="text-sm font-semibold mb-4">You can change this later in Settings &gt; Team</div>
        <button className="btn btn-blue w-80 mt-auto" onClick={handleCreate} disabled={saving}>
          {saving ? "Creating Team..." : "Create Team"}
        </button>
      </div>
    </Modal>
  );
}

export default CreateTeamModal;
